/** 网络通道选择（内网加速 / 公网访问）：用户选择存 localStorage，请求按它传 network_type */

const STORAGE_KEY = 'xbrainnet.network_mode';

export const NETWORK_INTERNAL = 'internal';
export const NETWORK_EXTERNAL = 'external';

/** 通道值 → 展示文案 */
export const NETWORK_LABELS = {
  [NETWORK_INTERNAL]: '内网加速',
  [NETWORK_EXTERNAL]: '公网访问',
};

/** 读取用户选择；无记录（未选择过）返回 null */
export function getNetworkMode() {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === NETWORK_INTERNAL || v === NETWORK_EXTERNAL ? v : null;
}

/** 写入用户选择 */
export function setNetworkMode(mode) {
  localStorage.setItem(STORAGE_KEY, mode);
}

/** 解析当前通道：用户选择优先，缺省内网 */
export function resolveNetworkType() {
  return getNetworkMode() || NETWORK_INTERNAL;
}
